/* eslint-disable react-hooks/rules-of-hooks */
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { getBaseUrl, getZeissIDAuthBaseUrl } from "Utils/getBaseUrl";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { bindActionCreators } from "redux";
import { ZuiProgressRing } from "@zeiss/zui-react";
import "@zeiss/zui";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		"& > * + *": {
			marginLeft: theme.spacing(2),
		},
	},
	progressRoot: {
		display: "inline-block",
	},
	progress: {
		position: "absolute",
		margin: "auto",
		top: 0,
		bottom: 0,
		left: 0,
		right: 0,
	},
}));

const Logout = (props) => {
	const classes = useStyles();
	const [isloggingut] = useState(true);
	const { reduxState, reduxActions } = props;
	const { userAccount } = reduxState;
	const { getUserAccount } = reduxActions;
	useEffect(() => {
		const applicationUrl = getBaseUrl();
		const ZeissIdAuthUrl = getZeissIDAuthBaseUrl();
		if (window.location.hostname.includes("localhost")) {
			window.location.href = `${ZeissIdAuthUrl}/Logout?p=B2C_1A_ZeissIdNormalSignIn&post_logout_redirect_uri=${applicationUrl}`;
		} else if (window.location.hostname.includes("dev")) {
			window.location.href = `${ZeissIdAuthUrl}/Logout?p=B2C_1A_ZeissIdNormalSignIn&post_logout_redirect_uri=${applicationUrl}`;
		} else if (window.location.hostname.includes("demo")) {
			window.location.href = `${ZeissIdAuthUrl}/Logout?p=B2C_1A_ZeissIdNormalSignIn&post_logout_redirect_uri=${applicationUrl}`;
		} else if (window.location.hostname.includes("fd-fkgen-qa")) {
			window.location.href = `${ZeissIdAuthUrl}/Logout?p=B2C_1A_ZeissIdNormalSignIn&post_logout_redirect_uri=${applicationUrl}`;
		} else if (window.location.hostname.includes("qa")) {
			window.location.href = `${ZeissIdAuthUrl}/Logout?p=B2C_1A_ZeissIdNormalSignIn&post_logout_redirect_uri=${applicationUrl}`;
		} else {
			window.location.href = `${ZeissIdAuthUrl}/Logout?p=B2C_1A_ZeissIdNormalSignIn&post_logout_redirect_uri=${applicationUrl}`;
		}
	}, [getUserAccount, userAccount.stateValue]);

	return isloggingut ? (
		<div className={classes.root}>
			<div
				className={`${classes.progressRoot} ${classes.progress}`}
				role="progressbar"
				style={{ width: "40px", height: "40px" }}
			>
				<ZuiProgressRing size="m"></ZuiProgressRing>
			</div>
		</div>
	) : (
		<Redirect to="/" />
	);
};

const mapDispatchToProps = (dispatch) => ({
	reduxActions: bindActionCreators(
		{
			getUserAccount: actions.getUserAccount,
		},
		dispatch
	),
});

const mapStateToProps = (state) => ({
	reduxState: {
		userAccount: state.userAccount,
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(Logout);
